<template>
  <div
    class="ce-searchResult ce-searchResult-document"
    :class="{'assets-visible': assetsVisible}">
    <div class="ce-searchResult-document-header">
      <div class="ce-documentResults-col ce-col1">
        <div class="ce-documentResult-rowToggle">
          <a
            href=""
            @click.prevent="toggleAssets">
            <fa-icon icon="angle-down" />
          </a>
        </div>
        <div class="ce-documentResult-selectCta">
          <checkbox
            class="ce-checkbox--small"
            :id="`pigment-${pigment.id}`"
            :value="isInBasket"
            :partially-checked="partiallyInBasket"
            @input="toggleBasket"
            :show-label="false" />
        </div>

        <result-state-indicators
          v-if="isMySheets"
          :show-new="hasNewDocuments"
          :show-updated="hasNewDocumentVersions" />
      </div>
      <div
        class="ce-documentResults-col ce-col2"
        @click.prevent="toggleAssets">
        {{ pigment.product_name }}

        <fa-icon
          v-if="pigment.isInternal"
          transform="up-5 shrink-4"
          icon="lock" />

        <fa-icon
          v-if="pigment.isActive === false"
          transform="up-5 shrink-4"
          icon="power-off" />
      </div>
      <div class="ce-documentResults-col ce-col3" />
      <div class="ce-documentResults-col ce-col4" />
      <div class="ce-documentResults-col ce-col5" />
      <div class="ce-documentResults-col ce-col6">
        <div class="ce-documentResult-favoriteCta">
          <a
            href=""
            @click.prevent="toggleFavorite">
            <fa-icon :icon="favoriteStateIcon" />
          </a>
        </div>
      </div>
    </div>
    <transition
      :css="false"
      @enter="enterAnimation"
      @leave="leaveAnimation">
      <div
        class="ce-searchResult-document-assets"
        v-if="assetsVisible">
        <document-result-group
          v-for="(assets, type) in groupedAssets"
          :key="`asset-type-${type}`"
          :assets="assets"
          :product="pigment" />
      </div>
    </transition>
  </div>
</template>

<script>
import DocumentResult from 'mixins/product-sheets/DocumentResult';

export default {
  mixins: [DocumentResult]
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';

  .ce-searchResult-document {
    .noselect;
    &:nth-child(2n + 1) {
      background: @color-mono-92;

      &.assets-visible .ce-searchResult-document-header {
        border-bottom-color: @color-mono-80;
      }

      .ce-resultStateIndicators > div:nth-child(2) {
        border-color: @color-mono-92;
      }

      .ce-searchResult-documentAsset {
        border-bottom-color: @color-mono-80;
        &:hover {
          background: @color-mono-80;
        }
      }
    }

    .ce-searchResult-document-header {
      display: flex;
      border-bottom: 1px solid @color-mono-92;
      transition: all 250ms ease-in-out;
      padding: @space-3 @space-2;

      .ce-documentResults-col {
        &.ce-col1 {
          .ce-documentResult-rowToggle {
            svg {
              transition: all 250ms ease-in-out;
            }
          }
        }
      }

      &:hover {
        background: @color-mono-92;
      }
    }

    .ce-documentResults-col {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.ce-col1, &.ce-col6 {
        display: flex;
        .mxn1;
        align-items: center;

        > * {
          margin: 0 @space-1;
        }
      }

      &.ce-col2 {
        cursor: pointer;
      }
    }

    &.assets-visible {
      .ce-searchResult-document-header {
        .ce-documentResults-col {
          &.ce-col1 {
            .ce-documentResult-rowToggle {
              svg {
                transform: rotate(180deg);
              }
            }
          }

          &.ce-col2 {
            font-weight: 700;
          }
        }
      }
    }
  }
</style>
